/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataAdminStockDepletedListResVo } from './PageDataAdminStockDepletedListResVo';
import {
    PageDataAdminStockDepletedListResVoFromJSON,
    PageDataAdminStockDepletedListResVoFromJSONTyped,
    PageDataAdminStockDepletedListResVoToJSON,
    PageDataAdminStockDepletedListResVoToJSONTyped,
} from './PageDataAdminStockDepletedListResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataAdminStockDepletedListResVo
 */
export interface ResponsePageDataAdminStockDepletedListResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataAdminStockDepletedListResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataAdminStockDepletedListResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataAdminStockDepletedListResVo}
     * @memberof ResponsePageDataAdminStockDepletedListResVo
     */
    data?: PageDataAdminStockDepletedListResVo;
}

/**
 * Check if a given object implements the ResponsePageDataAdminStockDepletedListResVo interface.
 */
export function instanceOfResponsePageDataAdminStockDepletedListResVo(value: object): value is ResponsePageDataAdminStockDepletedListResVo {
    return true;
}

export function ResponsePageDataAdminStockDepletedListResVoFromJSON(json: any): ResponsePageDataAdminStockDepletedListResVo {
    return ResponsePageDataAdminStockDepletedListResVoFromJSONTyped(json, false);
}

export function ResponsePageDataAdminStockDepletedListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataAdminStockDepletedListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataAdminStockDepletedListResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataAdminStockDepletedListResVoToJSON(json: any): ResponsePageDataAdminStockDepletedListResVo {
    return ResponsePageDataAdminStockDepletedListResVoToJSONTyped(json, false);
}

export function ResponsePageDataAdminStockDepletedListResVoToJSONTyped(value?: ResponsePageDataAdminStockDepletedListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataAdminStockDepletedListResVoToJSON(value['data']),
    };
}

